import React from 'react';
import './ArrayContact.css';

function ArrayContact() {
  return (
    <div>

      {/* Header */}
      <div className="contact-header">
        <div className="overlay"></div>
        <div className="header-content text-center">
          <span className="breadcrumb text-warning">
            <a href="/" className="text-warning text-decoration-none">الرئيسية</a> / تواصل معنا
          </span>
          <h1 className="mt-3 fw-bold display-4">تواصل معنا</h1>
          <p className="mt-2 fs-5 text-light">يمكنك التواصل معنا لأي استفسار أو طلب خدمة</p>
        </div>
      </div>

      {/* Contact Section */}
      <section className="contact-main section py-5">
        <div className="container">
          <div className="grid-two-columns">

            {/* Contact Info */}
            <div className="contact-info-card">
              <h6 className='text-warning'>|تواصل معنا</h6>
              <h2 className="fw-bold mb-3">تواصل مع فريقنا</h2>
              <p>للحصول على استشارة أو معرفة المزيد عن مشاريعنا، تواصل معنا عبر المعلومات التالية أو عبر النموذج المرفق.</p>

              <div className="info-item">
                <img src="/assets/images/phone-icon.png" alt="Phone" />
                <h5> +2095176686  
                  

               <span>رقم الهاتف</span></h5>
              </div>

              <div className="info-item">
                <img src="/assets/images/email-icon.png" alt="Email" />
                <h5>pyramid01008000@gmail.com
 <span>البريد الإلكتروني</span></h5>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-card">
              <form id="contact-form" action="" method="post">
                <div className="form-group">
                  <label htmlFor="name">الاسم الكامل</label>
                  <input type="text" id="name" name="name" placeholder="اسمك..." required />
                </div>

                <div className="form-group">
                  <label htmlFor="email">البريد الإلكتروني</label>
                  <input type="email" id="email" name="email" placeholder="البريد الإلكتروني..." required />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">الموضوع</label>
                  <input type="text" id="subject" name="subject" placeholder="الموضوع..." />
                </div>

                <div className="form-group">
                  <label htmlFor="message">الرسالة</label>
                  <textarea id="message" name="message" rows="5" placeholder="اكتب رسالتك هنا..."></textarea>
                </div>

                <button type="submit">إرسال الرسالة</button>
              </form>
            </div>

          </div>

          {/* Map */}
          <div className="map-wrapper">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d215.81835894812772!2d31.4546479!3d30.0628473!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145819000312aa07%3A0x66c86ace9d8c57af!2z2YHZitmE2KcgMTM!5e0!3m2!1sar!2seg!4v1769521063054!5m2!1sar!2seg"
              width="100%"
              height="500"
              allowFullScreen=""
              loading="lazy"
              title="Pyramid Construction Location"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

    </div>
  );
}

// Footer Component
function Footer() {
  return (
    <footer className="footer-contact">
      <div>&copy; {new Date().getFullYear()} Pyramid Construction. جميع الحقوق محفوظة.</div>
      <div>
        Design: <a href="https://www.facebook.com/share/1GCNH4sWyZ/" target="_blank" rel="noopener noreferrer">Mohamed Alaa</a>
      </div>
    </footer>
  );
}

export default ArrayContact;
